<template>
  <el-card v-loading="loading">
    <el-form class="global-form3" :model="info" ref="info" :rules="rules" label-position="left" label-width="120px">
      <div class="item-line mb20">
        <el-form-item label="项目名称" prop="projectId">
          <el-select disabled v-model="info.projectId" placeholder="请选择所属项目">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mb20" label="日报日期" prop="dailyDate">
          <el-date-picker disabled v-model="info.dailyDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择使用日期">
          </el-date-picker>
        </el-form-item>
      </div>
      <div class="item-line mb20">
        <el-form-item label="现场管理人员" prop="manageUserIds">
          <el-select v-model="info.manageUserIds" multiple placeholder="请选择现场管理人员">
            <el-option v-for="item in projectUserList" :key="item.userId" :label="item.userName" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="selction" v-if="templateList.attendance">
        <div class="selction_title">
          <div class="left">
            <img src="@/assets/img/daily/attendance.svg" />
            劳务考勤
          </div>
        </div>
        <div class="selction_info ">
          <!-- <div> -->
          <el-table class="global-table global-tables my-table" max-height="208" :data="attendanceList" border
            ref="table_tomorrow">
            <el-table-column label="班组名称" show-overflow-tooltip prop="teamName"></el-table-column>
            <el-table-column label="班组负责人" show-overflow-tooltip prop="teamLeader"></el-table-column>
            <el-table-column label="上班签到人数" show-overflow-tooltip prop="onSignNum"></el-table-column>
            <el-table-column label="下班签到人数" show-overflow-tooltip prop="offSignNum"></el-table-column>
            <el-table-column label="签到情况" min-width="100px" show-overflow-tooltip prop="signStatus">
              <template v-slot="{ row }">
                <div style="display:flex;align-items:center;">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">{{ row.signStatus | getStatusName2 }}</div>
                    <span>{{ row.signStatus | getStatusName }}</span>
                  </el-tooltip>
                  <img v-if="row.signStatus !== '1'" :src="require('@/assets/img/attendance/exclamationPoint.svg')"
                    style="margin-left: 5px;" alt="" srcset="">
                </div>
              </template>
            </el-table-column>
            <el-table-column label="加班人数" show-overflow-tooltip prop="overtimeNum"></el-table-column>
            <el-table-column label="加班合计时长" show-overflow-tooltip prop="totalOvertimeHours"></el-table-column>
          </el-table>

          <!-- <div v-else class="no-data" >
              <img src="@/assets/img/empty.svg"/>
          </div> -->

        </div>
      </div>
      <div class="selction" v-if="templateList.orderIds">
        <div class="selction_title">
          <div class="left">
            <span style="color: #F56C6C;margin-right: 4px;font-size: 14px;">*</span> <img
              src="@/assets/img/daily/order.svg" />
            养护作业
          </div>
        </div>
        <div class="selction_info">
          <div class="mb20 ">
            <el-button type="primary" @click="showWorkOrder">选择</el-button>
          </div>
          <el-table class="global-table global-tables table_attendance" max-height="400" :data="info.orderIds" border
            ref="table_order">
            <el-table-column label="工单主题" show-overflow-tooltip prop="orderTitle"></el-table-column>
            <el-table-column label="作业区域" show-overflow-tooltip prop="projectAreaName"></el-table-column>
            <el-table-column label="工单详情" show-overflow-tooltip prop="orderContent"></el-table-column>
            <el-table-column label="作业地点" show-overflow-tooltip prop="address"></el-table-column>
            <el-table-column label="作业日期" show-overflow-tooltip prop="orderDate"></el-table-column>
            <el-table-column label="工单状态" show-overflow-tooltip prop="machineryModel">
              <template v-slot="{ row }">{{ row.orderStatus | orderStatus }}</template>
            </el-table-column>
            <el-table-column label="操作" width="100px" fixed="right" align="center">
              <template v-slot="{ $index }">
                <el-button type="text" @click="onDelete($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="selction" v-if="templateList.material">
        <div class="selction_title">
          <div class="left">
            <!-- <span style="color: #F56C6C;margin-right: 4px;font-size: 14px;">*</span> -->
            <img src="@/assets/img/daily/material.svg" />
            物料信息
          </div>
        </div>
        <div class="selction_info">
          <div class="mb20 ">
            <el-radio-group v-model="activeName" @change="handleClick" class="radioGroup">
              <el-radio-button label="1">入库</el-radio-button>
              <el-radio-button label="2">出库</el-radio-button>
            </el-radio-group>
          </div>
          <el-table class="global-table global-tables table_attendance" :data="materialList" max-height="400" border
            ref="table_order">
            <el-table-column min-width="100" showOverflowTooltip label="物料分类" prop="materialTypeName"></el-table-column>
            <el-table-column min-width="100" showOverflowTooltip label="产品名称" prop="materialName"></el-table-column>
            <el-table-column min-width="100" showOverflowTooltip label="规格型号" prop="specifications"></el-table-column>
            <el-table-column min-width="100" showOverflowTooltip label="品牌名称" prop="brand"></el-table-column>
            <el-table-column min-width="100" showOverflowTooltip label="数量" prop="operationStock"></el-table-column>
            <el-table-column min-width="100" showOverflowTooltip label="仓库" prop="warehouseName"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="selction" v-if="templateList.taiBan">
        <div class="selction_title">
          <div class="left">
            <img src="@/assets/img/daily/taiban.svg" />
            台班劳务
          </div>
        </div>
        <div class="selction_info ">
          <!-- <div> -->
          <el-table class="global-table global-tables my-table" max-height="208" :data="taiBanList" border
            ref="table_tomorrow">
            <el-table-column label="机械名称" show-overflow-tooltip prop="machineryName"></el-table-column>
            <el-table-column label="规格型号" show-overflow-tooltip prop="specificationModel"></el-table-column>
            <el-table-column label="供应商" show-overflow-tooltip prop="supplierName"></el-table-column>
            <el-table-column label="台班/小时数" show-overflow-tooltip prop="hours"></el-table-column>
            <el-table-column label="作业内容" show-overflow-tooltip prop="jobContent"></el-table-column>
          </el-table>

          <!-- <div v-else class="no-data" >
              <img src="@/assets/img/empty.svg"/>
          </div> -->

        </div>
      </div>
      <div class="selction" v-if="templateList.dailyBak">
        <div class="selction_title">
          <div class="left">
            <span style="color: #F56C6C;margin-right: 4px;font-size: 14px;">*</span>
            <img src="@/assets/img/daily/thing.svg" />
            今日总结
          </div>
        </div>
        <div class="selction_info">
          <el-input v-model="info.dailyBak" type="textarea" :rows="5" style="width:70%" placeholder="请输入今日总结"
            show-word-limit maxlength="300"></el-input>
        </div>
      </div>
      <div class="selction" v-if="templateList.tomorrowOrder">
        <div class="selction_title">
          <div class="left">
            <img src="@/assets/img/daily/tommrow.svg" />
            明日计划
          </div>
        </div>
        <div class="selction_info">
          <div class="mb20 ">
            <el-button type="primary" @click="addTask">新增</el-button>
          </div>
          <el-table class="global-table global-tables my-table" max-height="400" :data="info.tomorrowOrderList" border
            ref="table_tomorrow">
            <el-table-column label="工单主题" show-overflow-tooltip prop="orderTitle"></el-table-column>
            <el-table-column label="工单详情" show-overflow-tooltip prop="orderContent"></el-table-column>
            <el-table-column label="作业区域" show-overflow-tooltip prop="projectAreaId">
              <template v-slot="{ row }">
                {{ getAreaName(row.projectAreaId) }}
              </template>
            </el-table-column>
            <el-table-column label="指派处理人" show-overflow-tooltip prop="orderUserId">
              <template v-slot="{ row }">
                {{ getOrderName(row.orderUserId) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100px" fixed="right" align="center">
              <template v-slot="{ $index }">
                <el-button type="text" @click="onDelete2($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div style="text-align:center">
        <el-button type="primary" v-loading="loadingSubmit" @click="onSubmit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </div>
    </el-form>

    <el-dialog title="养护工单" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
      <el-form class="global-form" inline label-width="100px">
        <el-form-item>
          <el-input v-model="workOrderForm.orderTitle" maxlength="30" placeholder="工单主题/ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="workOrderForm.orderType" clearable placeholder="工单类型">
            <el-option v-for="item in typeList" :key="item.orderType" :label="item.orderTypeName"
              :value="item.orderType"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearchWorkOrder">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="table" @selection-change="selectionLineChangeHandle" class="global-table" row-key="orderId"
        :data="workOrderItems">
        <el-table-column show-overflow-tooltip reserve-selection type="selection"></el-table-column>
        <!-- :selectable="selectable" -->
        <el-table-column show-overflow-tooltip prop="orderId" label="工单ID"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderTypeName" label="工单类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderTitle" label="工单主题"></el-table-column>
        <el-table-column show-overflow-tooltip prop="projectAreaName" label="作业区域"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderDate" label="作业日期"></el-table-column>
        <el-table-column prop="" label="状态">
          <template v-slot="{ row }">{{ row.orderStatus | orderStatus }}</template>
        </el-table-column>
      </el-table>

      <global-pagination @size-change="getWorkList" @current-change="getWorkList" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>
      <el-button type="primary" @click="confirmWorkOrder">确定</el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
    </el-dialog>

    <Addtask ref="task" @onAddTask='onAddTask' :disabled='submitShow' :projectId="info.projectId" :areaList='areaList'
      :dialogVisible2.sync="dialogVisible2"></Addtask>
  </el-card>
</template>

<script>
import Addtask from './Addtask.vue'

export default {
  name: 'AddMaintenanceDay',
  components: { Addtask },
  data () {
    return {
      loading: false,
      loadingSubmit: false,
      projectUserList: [],
      submitShow: false,
      activeName: '1',
      info: {
        projectId: '', // 项目ID
        dailyDate: '', // 日报日期
        manageUserIds: [], // 项目管理人员IDS
        orderIds: [], // 养护工单IDS
        dailyBak: '', // 今日总结
        tomorrowOrderList: [] // 明日工单列表
      },

      // 控制是否显示
      templateList: {
        attendance: false, // 考勤劳务
        orderIds: false, // 养护作业
        material: false, // 物料管理
        taiBan: false, // 台班劳务
        dailyBak: false, // 今日总结
        tomorrowOrder: false // 明日工单列表
      },

      page: 1,
      total: 0,
      size: 10,

      dialogVisible: false, // 工单类型
      dialogVisible2: false, // 任务工单
      workOrderForm: {
        orderTitle: '',
        orderType: ''
      },

      areaList: [], // 作业区域

      attendanceList: [], // 劳务考勤列表
      typeList: [], // 工单类型
      workOrderItems: [], // 工单列表
      selectItems: [], // 选中的临时工单
      materialList: [], // 物料列表
      taiBanList: [], // 台班列表
      rules: {
        projectId: [
          { required: true, message: '请选择项目名称', trigger: ['blur', 'change'] }
        ],
        dailyDate: [
          { required: true, message: '请选择日报日期', trigger: ['blur', 'change'] }
        ],
        manageUserIds: [
          { required: true, message: '请选择现场管理人员', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    projectId () {
      return this.$route.query.projectId
    },

    projectList () {
      return this.$store.state.projectList
    },

    dailyDate () {
      return this.$route.query.dailyDate
    },

    dailyId () {
      return this.$route.query.dailyId
    }

  },

  filters: {
    orderStatus: function (value) {
      if (value) {
        if (value === '0') {
          return '待反馈'
        } else if (value === '1') {
          return '待审核'
        } else if (value === '2') {
          return '已完成'
        } else if (value === '3') {
          return '已关闭'
        } else {
          return '--'
        }
      }
    },
    getStatusName: function (value) {
      // 签到状态 1正常 2缺上班签到 3缺下班签到 4上下班人数不一致
      if (value) {
        if (value === '1') {
          return '正常'
        } else {
          return '异常'
        }
      }
    },
    getStatusName2: function (value) {
      if (value) {
        if (value === '1') {
          return '正常'
        } else if (value === '2') {
          return '缺上班签到'
        } else if (value === '3') {
          return '缺下班签到'
        } else if (value === '4') {
          return '上下班人数不一致'
        } else {
          return '--'
        }
      }
    }
  },

  created () {
    // console.log('created3', this.$route.query.projectId)
    this.getProjectUserList() // 获取项目下人员
    this.getAreaList() // 获取作业区域
    this.info.projectId = this.projectId
    this.info.dailyDate = this.dailyDate
    if (this.dailyId) {
      this.getMaintenanceDayDetails() // 日报详情
    }
    this.getProjectDailyTemplate() // 查询项目的日报项配置列表
  },
  methods: {
    addTask () {
      this.dialogVisible2 = true
    },
    getMaintenanceDayDetails () {
      this.$axios.get(this.$apis.maintenanceDaily.selectYhProjectDailyShareDetail, {
        dailyId: this.dailyId
      }).then(res => {
        // res.dailyOptionIds.forEach((item: any) => {
        //   if (item === '1') {
        //     this.getAttendance() // 查询项目日报-劳务考勤
        //     this.templateList.attendance = true
        //   } else if (item === '2') {
        //     this.templateList.orderIds = true
        //     this.getDailyOrder() // 查询项目日报-养护作业
        //   } else if (item === '3') {
        //     this.templateList.material = true
        //     this.getMaterial({
        //       projectId: this.projectId,
        //       detailedType: '1',
        //       storageDate: this.dailyDate
        //     })
        //   } else if (item === '4') {
        //     this.templateList.taiBan = true
        //     this.getTaiBan()
        //   } else if (item === '5') {
        //     this.templateList.dailyBak = true
        //   } else if (item === '6') {
        //     this.templateList.tomorrowOrder = true
        //     this.getTomorrowPlan() // 查询项目日报-明日计划
        //   }
        // })

        this.info = res
        this.info.manageUserIds = res.manageUserList.map((item) => {
          return item.manageUserId
        }) || []
      })
    },

    getProjectDailyTemplate () {
      this.$axios.get(this.$apis.maintenanceDaily.selectProjectOptionList, {
        projectId: this.projectId
      }).then(res => {
        // console.log('项目的日报项配置列表', res)
        res.forEach((item) => {
          if (item.dailyOptionType === '1') {
            this.getAttendance() // 查询项目日报-劳务考勤
            this.templateList.attendance = true
          } else if (item.dailyOptionType === '2') {
            // 校验会有问题
            this.templateList.orderIds = true
            if (this.dailyId) {
              this.getDailyOrder() // 查询项目日报-养护作业
            } else {
              this.getorders() // 获取养护作业（上一天的明日计划）
            }
          } else if (item.dailyOptionType === '3') {
            this.templateList.material = true
            this.getMaterial({
              projectId: this.projectId,
              detailedType: '1',
              storageDate: this.dailyDate
              // checkoutDate: this.dailyDate
            })
          } else if (item.dailyOptionType === '4') {
            this.templateList.taiBan = true
            this.getTaiBan()
          } else if (item.dailyOptionType === '5') {
            this.templateList.dailyBak = true
          } else if (item.dailyOptionType === '6') {
            this.templateList.tomorrowOrder = true
            if (this.dailyId) {
              this.getTomorrowPlan() // 查询项目日报-明日计划
            }
          }
        })
        // this.attendanceList = res.attendanceList
      })
    },

    getTomorrowPlan () {
      this.$axios.get(this.$apis.maintenanceDaily.selectDailyTomorrowPlan, {
        dailyId: this.dailyId
      }).then(res => {
        // console.log('res', res)
        this.info.tomorrowOrderList = res.orderList
      })
    },

    handleClick (value) {
      // console.log('handle', value)
      if (value === '1') {
        this.getMaterial({
          projectId: this.projectId,
          detailedType: '1',
          storageDate: this.dailyDate
          // checkoutDate: this.dailyDate
        })
      } else {
        this.getMaterial({
          projectId: this.projectId,
          detailedType: '2',
          // storageDate: this.dailyDate
          checkoutDate: this.dailyDate
        })
      }
    },

    // 获取区域
    getAreaList () {
      this.$axios.get(this.$apis.project.selectYhProjectAreaByList, {
        projectId: this.projectId
      }).then(res => {
        this.areaList = res || []
      })
    },

    // 项目人员列表
    getProjectUserList () {
      this.$axios.get(this.$apis.project.selectYhProjectUserByList, {
        projectId: this.projectId
      }).then(res => {
        // console.log('用户列表', res)
        this.projectUserList = res || []
      })
    },

    // 获取考勤
    getAttendance () {
      this.$axios.get(this.$apis.maintenanceDaily.selectLabourServiceStatisticByDaily, {
        projectId: this.projectId,
        attendanceDate: this.dailyDate
      }).then(res => {
        // console.log('劳务考勤', res)
        this.attendanceList = res.attendanceList
      })
    },

    //  获取养护作业（上一天的明日计划，新增时使用）
    getorders () {
      this.$axios.get(this.$apis.maintenanceDaily.selectYhProjectDailyTomorrowPlanList, {
        projectId: this.projectId,
        dailyDate: this.dailyDate
      }).then(res => {
        console.log('养护res', res)
        this.info.orderIds = res || []
        this.selectItems = res || []
      })
    },

    //  获取养护作业（编辑时使用）
    getDailyOrder () {
      this.$axios.get(this.$apis.maintenanceDaily.selectDailyOrder, {
        dailyId: this.dailyId
      }).then(res => {
        this.info.orderIds = res.orderlist || []
        this.selectItems = res.orderlist || []
      })
    },

    // 获取物料
    getMaterial (params) {
      this.$axios.get(this.$apis.maintenanceDaily.selectYhDetailedDaily, params).then(res => {
        this.materialList = res.yhDetailedList
      })
    },

    // 获取台班
    getTaiBan () {
      this.$axios.get(this.$apis.maintenanceDaily.selectYhMachineTeamLineByList, {
        projectId: this.projectId,
        machineTeamDate: this.dailyDate
      }).then(res => {
        // console.log('劳务考勤', res)
        this.taiBanList = res.list
      })
    },

    // 展示工单
    showWorkOrder () {
      // this.page = 1
      this.dialogVisible = true
      this.getWorkTypeList()
      this.getWorkList()
      this.$nextTick(() => {
        // console.log('this.info.orderIds', this.info.orderIds)
        // console.log('打开弹框this.selectItems', this.selectItems)
        this.$refs.table.clearSelection()
        this.info.orderIds.forEach(item => {
          this.$refs.table.toggleRowSelection(item, true)
        })
      })
    },

    // 加载工单类型
    getWorkTypeList () {
      // this.searchInfo.orderType = ''
      this.$axios.get(this.$apis.workOrder.selectWorkOrderTypeByList, {
        projectId: this.info.projectId,
        orderTypeStatus: '1'
      }).then((res) => {
        this.typeList = res.list || []
      })
    },

    // 加载工单
    getWorkList () {
      // this.tableData.loading = true
      this.$axios.get(this.$apis.workOrder.selectWorkOrderByPage, {
        ...this.workOrderForm,
        projectId: this.info.projectId,
        page: this.page,
        size: this.size,
        orderOtherStatus: '1'
      }).then((res) => {
        this.total = res.total || 0
        this.workOrderItems = res.list || []
      }).finally(() => {
        // this.tableData.loading = false
      })
    },

    onSearchWorkOrder () {
      this.page = 1
      this.getWorkList()
    },

    // selectable (row: any) {
    //   return !this.info.orderIds.some((item: any) => item.orderId === row.orderId)
    // }

    selectionLineChangeHandle (val) {
      this.selectItems = val
    },

    // 选择工单
    confirmWorkOrder () {
      // console.log('选择养护工单', this.formData.flowOrderList)
      // console.log('this.selectItems', this.selectItems)
      this.info.orderIds = this.selectItems
      // console.log('items', items)
      this.dialogVisible = false
    },

    // 删除养护作业
    onDelete (index) {
      this.info.orderIds.splice(index, 1)
      // this.selectItems.splice(index, 1)
    },

    // 删除明日计划
    onDelete2 (index) {
      this.info.tomorrowOrderList.splice(index, 1)
      // this.selectItems.splice(index, 1)
    },

    // 添加明日任务
    onAddTask (item) {
      this.info.tomorrowOrderList.push(item)
      this.$refs.task.handleClose()
    },

    onSubmit () {
      // console.log('info', this.info);
      this.$refs.info.validate(valid => {
        if (valid) {
          if (this.templateList.orderIds && !this.info.orderIds.length) {
            this.$message({ type: 'warning', message: '请至少添加一条养护作业' })
            return
          }
          if (this.templateList.dailyBak && !this.info.dailyBak) {
            this.$message({ type: 'warning', message: '请输入今日总结' })
            return
          }
          if (!this.info.orderIds.length && !this.info.dailyBak && !this.info.tomorrowOrderList.length) {
            this.$message({ type: 'warning', message: '请至少填写一项日报项' })
            return
          }

          const params = JSON.parse(JSON.stringify(this.info))
          params.orderIds = params.orderIds.map((item) => {
            return item.orderId
          })
          this.submitShow = true
          const url = this.dailyId ? this.$apis.maintenanceDaily.updateYhProjectDaily : this.$apis.maintenanceDaily.insertYhProjectDaily
          this.$axios.post(url, params).then(() => {
            this.$message.success('操作成功')
            // this.handleClose()
            this.$router.back()
            // this.$emit('success')
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    },

    getOrderName (value) {
      if (value) {
        const target = this.projectUserList.find((item) => {
          return item.userId === value
        })
        return target.userName
      }
    },

    getAreaName (value) {
      if (value) {
        const target = this.areaList.find((item) => {
          return item.projectAreaId === value
        })
        return target.areaName
      }
    }
  }

}
</script>

<style scoped lang="scss">
.radioGroup {
  margin: 0
}

.table_attendance {
  .el-tooltip {
    display: flex;
    align-items: center;

    img {
      margin-left: 5px;
    }
  }
}

// .el-form-item--small.el-form-item{
//   margin-bottom: 20px;
// }
// style="min-height: 100px;"
::v-deep .textarea {
  width: 70%;
}

::v-deep .el-form {
  padding: 0 30px
}

::v-deep .el-card__body {
  padding: 20px 0;
}

::v-deep .el-input__inner {
  // padding-right: 50px;
}

.my-table {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}

.item-line {
  display: flex;
  flex-wrap: wrap;
  height: 32px;

  // margin-bottom:10px;
  &>div {
    margin-right: 250px;
  }
}

.table {
  // padding-left: 20px;

  .instructions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
    }
  }

  p .cell.el-tooltip {
    white-space: unset !important;
  }

  ::v-deep .el-form-item__error {
    position: unset;
  }

  .cell {
    overflow: unset;
  }

  .el-select {
    width: auto;
  }

  ::v-deep .el-input {
    width: calc(100% - 20px);
  }
}

.disabled {
  color: #a09696;
}

.checkBox {
  width: 50%;
  margin: auto;

  .title {
    text-align: left;
  }

  .allChecked {
    display: flex;
    flex-direction: column;

    .el-checkbox {
      display: flex;
      align-items: center;
      margin: 7px 0;
    }
  }
}

.checkBoxItem {
  max-height: 170px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  .el-checkbox {
    display: flex;
    align-items: center;
    margin: 7px 0;
  }

  ::v-deep .el-checkbox__label {
    width: 340px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
}

.selction {
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(139, 172, 237, 0.2);
  border-radius: 20px;
  border: 1px solid #F0F3F6;
  margin-bottom: 20px;

  .selction_title {
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F4F4F4;
    font-weight: 500;
    font-size: 18px;
    color: #000000;

    .left {
      margin-left: 40px;
      line-height: 54px;
      height: 54px;
    }

    .right {
      display: flex;
      margin-right: 20px;
      align-items: center;
    }

    .more {
      font-size: 14px;
      font-weight: bold;
      color: var(--color-primary);
      margin-left: 12px;
    }
  }

  .selction_info {
    padding: 36px 40px
  }

}
</style>
